import { PayCode } from "@/data/pay-codes";

import { TimeReport } from "../types";

export const sortTimeReportPaycodes = (timeReport: TimeReport): PayCode[] => {
  const seenGuids = new Set<string>();
  const allPaycodes: PayCode[] = [];

  const project = timeReport.projects.find(p => p.items.length > 0);

  if (project) {
    project.items.forEach(({ payCode }) => {
      if (!seenGuids.has(payCode.guid)) {
        seenGuids.add(payCode.guid);
        allPaycodes.push(payCode);
      }
    });
  }

  return allPaycodes;
};
